import React, { Component } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import numeral from "../../../../node_modules/numeraljs/numeral.js";
import {
  MetricTable,
  sortNumeric,
  selectFormat,
  Error,
} from "./../../Utils/Utils.js";

const TableContentTitle = (cell, row, board) => {
  // Title
  let TITLE = "";
  if (cell.title !== null) {
    TITLE = <h1 className="content-table__title">{cell.title}</h1>;
  } else {
    TITLE = "";
  }

  return (
    <article className="content-table">
      <section className="content-table__detail">
        <a href={cell.url} target="_blank" rel="noopener noreferrer">
          {TITLE}
        </a>
      </section>
    </article>
  );
};

function metric(cell, row) {
  if (!cell || !cell.value) {
    return null;
  }

  if (cell.newValue) {
    return (
      <span className="metric-table">
        <span className="metric-table__primary">
          {numeral(cell.value).format("0.0a")}
        </span>{" "}
        <span className="metric-table__new">new</span>
      </span>
    );
  }

  return <MetricTable {...cell} />;
}

class TopReferrers extends Component {
  componentDidMount() {
    this.props.childRef(this);
  }

  renderTable(data) {
    const { cells, title } = this.props;

    // add unique ids
    data.forEach((d, i) => (d.id = i));

    const columns = [
      {
        dataField: "sref_domain",
        text: "Referrer",
        style: { width: "100px", minWidth: "100px", textAlign: "left" },
        headerAlign: "left",
      },
      {
        dataField: "top_article",
        text: "Top Article",
        style: { width: "230px", minWidth: "230px", textAlign: "left" },
        formatter: TableContentTitle,
        csvFormatter: (cell) => cell && cell.title,
        headerAlign: "left",
      },
      {
        dataField: "unique_visitors",
        text: "UVs",
        style: { width: "80px", minWidth: "80px" },
        formatter: metric,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "new_unique_visitors",
        text: "New UVs",
        style: { width: "80px", minWidth: "80px" },
        formatter: metric,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "returning_unique_visitors",
        text: "Returning UVs",
        style: { width: "80px", minWidth: "80px" },
        formatter: metric,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "pageview_count",
        text: "Page Views",
        style: { width: "80px", minWidth: "80px" },
        formatter: metric,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
    ];

    const defaultSorted = [
      {
        dataField: "unique_visitors",
        order: "desc",
      },
    ];

    let selected_columns = columns;
    if (cells && cells.length) {
      selected_columns = [];
      cells.forEach((cell, i) => {
        selected_columns.push(columns.find((o) => o.dataField === cell));
      });
    }

    const filename = title.split(" ").join("_") || "spreadsheet";
    return (
      <ToolkitProvider
        keyField="id"
        data={data}
        columns={selected_columns}
        striped={false}
        hover={false}
        bordered={false}
        exportCSV={{
          fileName: filename + ".csv",
          exportAll: false,
          onlyExportFiltered: true,
        }}
      >
        {(props) => (
          <BootstrapTable
            {...props.baseProps}
            {...props.csvProps}
            defaultSorted={defaultSorted}
            ref={(el) => (this.childRef = el)}
          />
        )}
      </ToolkitProvider>
    );
  }

  builtInExportCSV = () => this.childRef;

  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return this.renderTable(data.data);
  }
}

export default TopReferrers;
